import React from 'react'
import useQueuedSave from 'src/hooks/useQueuedSave'
import { Toggle } from '../primitives'

/**
 * Toggle that saves on every change. Its value shows at once and quick
 * repeated clicks are saved one after another, latest wins (useQueuedSave).
 * `persist(value)` must return a promise that rejects when the save fails;
 * the toggle then goes back to the last saved value.
 */
const SavingToggle = ({ checked, persist, disabled, title }) => {
  const [value, setValue] = useQueuedSave(Boolean(checked), persist)
  return (
    <Toggle
      checked={value}
      onChange={setValue}
      disabled={disabled}
      title={title}
    />
  )
}

export default SavingToggle
